import React from "react"
import { connect } from "react-redux"
import { func } from 'prop-types';

import { previous } from "../../logic/actions/navigation";
import "./style.css"
import Icon from "../Icon";

ButtonBack.propTypes = {
  previous: func,
  onClick: func,
}

export function ButtonBack({ onClick, previous }) {
  //fallback to onclick action
  return (
    <div className="button-back-container" onClick={onClick || previous}>
      <Icon name="Arrow-left" color="gray" /><span>back</span>
    </div>
  );
}

export default connect(null, { previous })(ButtonBack);

